import React from 'react';

import { flagStyles } from '../settings';

const SvgCF = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-936px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgCF;
